import React, { ReactNode } from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colorsAndLabelsByOp, styles } from "system/query/QueryUtility";
import { queryOps } from "system/query/Query";

export interface QueryBuilderAddButtonProps {
  op?: queryOps;
  onClick?: (op?: queryOps) => void;
  children?: ReactNode;
  labelOverride?: string;
}

export function QueryBuilderAddButton(props: QueryBuilderAddButtonProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const {borderColor, backgroundColor, label} = colorsAndLabelsByOp(i18n, theme.colors.namedColors, props.op);

  return (
    <Box sx={{
        position:'relative',
        p:1, m:1,
        border: `1px solid ${borderColor}`,
        borderRadius: styles.boxBorderRadius,
        textAlign:'center',
        fontWeight:'bold',
        backgroundColor: `${backgroundColor}`,
        cursor: props.onClick ? 'pointer' : 'default',
        "&:hover": {
          opacity: props.onClick ? 0.7 : 1,
        }
      }}
      onClick={() => props.onClick && props.onClick(props.op)} >
      {props.op && label}
      {!props.op && props.labelOverride}
      {!props.op && !props.labelOverride && i18n.t("query-form.add-filter")}
      {props.children}
    </Box>
  );
}
